import { createAction } from '@ngrx/store';

export const sendRequest = createAction('[HttpBusy Component] Send');
export const returnRequest = createAction('[HttpBusy Component] Return');
